import moment from 'moment-timezone';
import { EnterpriseDataCompletenessMetricStat } from './enterprise-data-completeness-metric-stat';

export class EnterpriseDashboardOverviewStats {
	public portfolioCostAvoidance: {
		currPeriodAmount: number;
		currPeriodLabel: string;
		prevPeriodAmount: number;
		changePercentage: number;
		secondaryPeriodAmount: number;
		secondaryPeriodLabel: string;
	};
	public portfolioUsage: {
		currPeriodAmount: number;
		currPeriodLabel: string;
		prevPeriodAmount: number;
		changePercentage: number;
		secondaryPeriodAmount: number;
		secondaryPeriodLabel: string;
	};
	public portfolioRenewableUsage: {
		currPeriodAmount: number;
		currPeriodLabel: string;
	};
	public portfolioBudgetCost: {
		currPeriodLabel: string;
		actualCost: number;
		nextBudgetCost: number;
	};
	public portfolioDataCompleteness: EnterpriseDataCompletenessMetricStat;
	public highlightsRenewals: {
		contractId: string;
		originContractId: string;
		expirationDate: string;
		daysToExpiration: number;
		dbaName: string;
		city: string;
		stateShort: string;
	}[];
	public highlightsTopContracts: {
		contractId: string;
		originContractId: string;
		dbaName: string;
		city: string;
		stateShort: string;
		costAvoidance: number;
		upToDate: string;
		numMonthsAgo: number;
	}[];
	public usageChartData: {
		usage: number;
		date: Date;
	}[];
	public annualImpactData: {
		yearDate: Date;
		year?: number;
		numContracts: number;
		costAvoidance: number;
	}[];
	public sustainabilityGoalData: {
		percentRenewable: number;
		currPeriodLabel: string;
	};

	constructor(enterpriseDashboardOverviewStats?: EnterpriseDashboardOverviewStats) {
		Object.assign(this, enterpriseDashboardOverviewStats);

		this.annualImpactData.forEach(data => {
			data.yearDate = data.yearDate ? moment(data.yearDate).toDate() : data.yearDate;
			data.year = data.yearDate.getFullYear();
		});
	}
}
